import { Component, OnInit, Input } from '@angular/core';
import { Partner } from '../../models/partner';

@Component({
  selector: 'app-partner-contact',
  templateUrl: './partner-contact.component.html',
  styleUrls: ['./partner-contact.component.css']
})
export class PartnerContactComponent implements OnInit {

  @Input() partner: Partner;

  constructor() { }

  ngOnInit() {
  }

}
